function CardSkeleton() {
  return (
    <div className="flex overflow-hidden border-[0.5px] border-[#C5E0FF] rounded-lg shadow-[1px_2px_8px_1px_rgba(219,219,219,0.45)] animate-pulse">
      {/* Imagen */}
      <div className="w-full md:w-1/2 h-48 bg-gray-200" />

      {/* Contenido */}
      <div className="flex flex-col justify-between flex-1 p-4 gap-3">
        <div className="h-6 w-3/4 bg-gray-200 rounded" />

        <div className="space-y-2">
          <div className="h-4 w-1/2 bg-gray-200 rounded" />
          <div className="h-4 w-1/3 bg-gray-200 rounded" />
          <div className="h-4 w-full bg-gray-200 rounded" />
          <div className="h-4 w-2/3 bg-gray-200 rounded" />
        </div>
      </div>
    </div>
  );
}

export default CardSkeleton;